import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import MarketPlaceFeedCurrentUserProfile from "./MarketPlaceFeedCurrentUserProfile";
import MarketPlaceFeedNavbar from "./MarketPlaceFeedNavbar";
import MarketPlaceFeedHome from "./MarketPlaceFeedHome";
import MarketPlaceFeedOpportunities from "./MarketPlaceFeedOpportunities";
import IndustryProfiles from "./IndependentResearcher/IndustryProfiles";
import UniversityAnnouncements from "../../pages/marketplace/IndependentResearcher/UniversityAnnouncements";
import MarketPlaceCourses from "./MarketPlaceCourses";

const MarketPlaceFeedLayout = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // URL is source of truth
  const tabFromUrl = searchParams.get("tab") || "feed";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  // sync state → URL
  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab]);

  // sync URL → state (refresh/back/forward safe)
  useEffect(() => {
    setActiveTab(tabFromUrl);
  }, [tabFromUrl]);

  return (
    <>
      <MarketPlaceFeedNavbar />

      <div className="container mx-auto md:px-4 mt-6 mb-4">
        <div className="flex relative">

          {/* Left */}
          <div className="hidden md:block w-1/4 px-2">
            <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
              <MarketPlaceFeedCurrentUserProfile />
            </div>
          </div>

          {/* Center */}
          <div className="w-full md:w-2/4 md:px-2">
            <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">

              {/* Tabs */}
              <div className="flex gap-4 w-full pb-4">

                <button
                  onClick={() => setActiveTab("feed")}
                  className={`w-1/2 py-2 text-center ${
                    activeTab === "feed"
                      ? "bg-blue-500"
                      : "bg-gray-200"
                  } text-white rounded-[10px]`}
                >
                  Feed
                </button>

                <button
                  onClick={() => setActiveTab("opportunity")}
                  className={`w-1/2 py-2 text-center ${
                    activeTab === "opportunity"
                      ? "bg-blue-500"
                      : "bg-gray-200"
                  } text-white rounded-[10px]`}
                >
                  Opportunity
                </button>

                <button
                  onClick={() => setActiveTab("announcement")}
                  className={`w-1/2 py-2 text-center ${
                    activeTab === "announcement"
                      ? "bg-[#0f6abf] hover:bg-[#0a5ca8]"
                      : "bg-gray-200"
                  } text-white rounded-[10px]`}
                >
                  Announcements
                </button>

                 <button
                  onClick={() => setActiveTab("courses")}
                  className={`w-1/2 py-2 text-center ${
                    activeTab === "courses"
                      ? "bg-[#0f6abf] hover:bg-[#0a5ca8]"
                      : "bg-gray-200"
                  } text-white rounded-[10px]`}
                >
                  University Courses
                </button>
              </div>

              {/* Content */}
              {activeTab === "feed" && (
                <MarketPlaceFeedHome/>
              )}

              {activeTab === "opportunity" && (
                <MarketPlaceFeedOpportunities />
              )}

              {activeTab === "announcement" && (
                <UniversityAnnouncements />
              )}
              {activeTab === "courses" && (
                <MarketPlaceCourses />
              )}
            </div>
          </div>

          {/* Right */}
          <div className="hidden md:block w-1/4 px-2">
            <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
              <IndustryProfiles />
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default MarketPlaceFeedLayout;